(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/purge-room.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/purge-room.js'); 'use strict';

const CHAT_PURGE_ROOM = 'CHAT/CHAT_PURGE_ROOM';
setGlobal('svs.components.chat.chatData.actions', {
  CHAT_PURGE_ROOM
});
 })(window);